import { AxiosError, AxiosResponse } from 'axios';
import {
    SPRAY_SUBMISSIONS_SET,
    SPRAY_SUBMISSIONS_CREATE_FAILED,
    SPRAY_SUBMISSIONS_CREATE_REQUESTED,
    SPRAY_SUBMISSIONS_CREATE_SUCCEEDED,
    SPRAY_SUBMISSIONS_LOAD_CANCELED,
    SPRAY_SUBMISSIONS_LOAD_FAILED,
    SPRAY_SUBMISSIONS_LOAD_REQUESTED,
    SPRAY_SUBMISSIONS_LOAD_SUCCEEDED,
    SPRAY_SUBMISSIONS_DELETE_REQUESTED,
    SPRAY_SUBMISSIONS_DELETE_SUCCEEDED,
    SPRAY_SUBMISSIONS_DELETE_FAILED
} from './constants';
import {
    RequestedCreateSubmissionAction,
    SucceededCreateSubmissionAction,
    FailedCreateSubmissionAction,
    SpraySubmission,
    SpraySubmissionId,
    SetSpraySubmissionsAction,
    RequestLoadSpraySubmissionsAction,
    SucceededLoadSpraySubmissionsAction,
    FailedLoadSpraySubmissionsAction,
    CanceledLoadSpraySubmissionsAction,
    SucceededDeleteSpraySubmissionsAction,
    RequestDeleteSpraySubmissionsAction,
    FailedDeleteSpraySubmissionsAction
} from './types';

export function setSpraySubmissions(
    payload: Record<SpraySubmissionId, SpraySubmission>
): SetSpraySubmissionsAction {
    return {
        type: SPRAY_SUBMISSIONS_SET,
        payload
    };
}

export function requestedCreateSpraySubmission(): RequestedCreateSubmissionAction {
    return {
        type: SPRAY_SUBMISSIONS_CREATE_REQUESTED
    };
}

export function succeededCreatedSpraySubmission(
    payload: SpraySubmission
): SucceededCreateSubmissionAction {
    return {
        type: SPRAY_SUBMISSIONS_CREATE_SUCCEEDED,
        payload
    };
}

export function failedCreatedSpraySubmission(
    error: AxiosError
): FailedCreateSubmissionAction {
    return {
        type: SPRAY_SUBMISSIONS_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestLoadSpraySubmissions(): RequestLoadSpraySubmissionsAction {
    return {
        type: SPRAY_SUBMISSIONS_LOAD_REQUESTED
    };
}

export function succeededLoadSpraySubmissions(
    response: AxiosResponse
): SucceededLoadSpraySubmissionsAction {
    return {
        type: SPRAY_SUBMISSIONS_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadSpraySubmissions(
    error: AxiosError
): FailedLoadSpraySubmissionsAction {
    return {
        type: SPRAY_SUBMISSIONS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function canceledLoadSpraySubmissions(): CanceledLoadSpraySubmissionsAction {
    return {
        type: SPRAY_SUBMISSIONS_LOAD_CANCELED
    };
}

export function requestDeleteSpraySubmissions(
    payload: SpraySubmissionId
): RequestDeleteSpraySubmissionsAction {
    return {
        type: SPRAY_SUBMISSIONS_DELETE_REQUESTED,
        payload
    };
}

export function succeededDeleteSpraySubmissions(
    payload: SpraySubmissionId
): SucceededDeleteSpraySubmissionsAction {
    return {
        type: SPRAY_SUBMISSIONS_DELETE_SUCCEEDED,
        payload
    };
}

export function failedDeleteSpraySubmissions(
    error: AxiosError
): FailedDeleteSpraySubmissionsAction {
    return {
        type: SPRAY_SUBMISSIONS_DELETE_FAILED,
        payload: error,
        error: true
    };
}
